import { FC } from 'react';
import { MoreVertical } from 'react-feather';

import MenuButton from '@/componentsv2/MenuButton';

export interface QueryAction {
  key: string;
  icon: FC<{ className?: string }>;
  label: string;
  tone?: 'brand' | 'destructive';
  onClick: () => void;
}

interface QueryActionsMenuProps {
  id: string;
  actions: QueryAction[];
}

/** The `⋯` overflow menu on a vetting query row / hidden row (ENG-5292). */
export function QueryActionsMenu({ id, actions }: QueryActionsMenuProps): JSX.Element {
  return (
    <MenuButton
      id={id}
      buttonProps={{
        variant: 'tertiary',
        startIcon: MoreVertical,
        startIconClassName: 'text-on-surface-subtle',
        srText: 'More actions',
        size: 'small',
      }}
    >
      {actions.map((action) => (
        <MenuButton.Item
          key={action.key}
          onClick={action.onClick}
          className={
            action.tone === 'destructive' ? 'text-destructive-primary' : 'text-brand-primary'
          }
        >
          <action.icon className="mr-8 h-16 w-16" />
          {action.label}
        </MenuButton.Item>
      ))}
    </MenuButton>
  );
}
